import { createAction, props } from '@ngrx/store';

import { GetAnimalManureTransportResponse } from '../models/animal-manure-transport.model';
import { FertilizerRequest } from '../models/fertilizer.model';

export const fertilizersUpdated = createAction('[Fertilizers] Fertilizers updated');

export const optimizeFertilizer = createAction(
  '[Fertilizers] Optimize fertilizer',
  props<{
    cropAidId: number;
    periodId: number;
    soilTypeId: number;
  }>(),
);

export const importMineralBalance = createAction(
  '[Manure space] import the select mineral balance lines',
  props<{ fertilizers: FertilizerRequest[] | null; isVDM?: boolean }>(),
);

export const startFertilizerImportDialogFlow = createAction(
  '[Fertilizers] Start fertilizer import dialog flow',
);

export const fetchAnimalManureTransports = createAction(
  '[Animal manure transport] Open the animal manure transport datepicking dialog',
);

export const openAnimalManureTransportsTable = createAction(
  '[Animal manure transport] Open the animal manure transports table dialog',
  props<{
    kvkNumber: string;
    startDate: string;
    endDate: string;
    defaultSoilType: number;
    animalManureTransports: GetAnimalManureTransportResponse;
  }>(),
);

export const fetchVzcTransports = createAction(
  '[VZC transport] Open the sewage sludge and compost transport import dialog',
);

export const openVzcTransportsTable = createAction(
  '[VZC transport] Open the vzc transports table dialog',
  props<{ kvkNumber: string; startDate: string; endDate: string }>(),
);
